import { FeatureFlagsManager } from "@/core/feature-flags/feature-flags.manager.js";

export const FeatureFlagsPlugin = {
  install(Vue) {
    Vue.prototype.$featureFlags = new FeatureFlagsManager();
  },
};
